import { highlightTitleWords } from '@helpers/utils';
import InformationCard from '@stories/Components/Cards/InformationCard/InformationCard';
import * as React from 'react';
import S from './InformationCards.styles';
const InformationCards = (props) => {
    if (!props.cards || props.cards.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { site: props.site, spacing: 'padding' },
        React.createElement(S.Title, { dangerouslySetInnerHTML: { __html: highlightTitleWords(props.title) } }),
        props.description && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: props.description } })),
        React.createElement(S.Cards, null, props.cards.map((card) => (React.createElement(InformationCard, { key: card.id, ...card, site: props.site }))))));
};
export default InformationCards;
